import React, { useEffect, useImperativeHandle, useState } from "react";
import FloatLayout from "@/components/float-layout";
import bridge from '@/config/JSbridge';
import ShareWeixin from '@/img/share/share_icon_weixin@2x.png';
import ShareWeixinFriend from '@/img/share/share_icon_friends@2x.png';
import ShareWeibo from '@/img/share/share_icon_weibo@2x.png';
import ShareQQ from '@/img/share/share_icon_qq@2x.png';
import { Container } from "../../activity_30/components/share";


const socialList = {
  qq: ShareQQ,
  wechat_friend: ShareWeixinFriend,
  wechat: ShareWeixin,
  // wechat_collect: 0,
  weibo: ShareWeibo,
  // sns: 0,
  // qzone: 0,
  // snapshot: 0
};

const socialItemName = {
  qq: 'QQ',
  wechat_friend: '朋友圈',
  wechat: '微信',
  weibo: '微博',
}

const ShareModal = React.forwardRef(({onShareClick, userName}, ref) => {
  const [visible, setVisible] = useState(false);
  const [social, setSocial] = useState([]);

  useImperativeHandle(ref, () => {
    return {
      show: () => setVisible(true)
    }
  })

  const showCanShare = (data) => {
    if (data.length > 0) {
      const nextSocialList = [];
 
      if (data.indexOf("wechat") !== -1) {
        nextSocialList.push('wechat')
      }
      if (data.indexOf("wechat_friend") !== -1) {
        nextSocialList.push('wechat_friend')
      }
      if (data.indexOf("weibo") !== -1) {
        // socialList.weibo = 1
        nextSocialList.push('weibo')
      }
      if (data.indexOf("qq") !== -1) {
        nextSocialList.push('qq')
      }
      
      setSocial(nextSocialList);
    }
  };

  const canShare = () => {
    let send = {
      event: "validSocial",
      params: {
        social: [
          "qq",
          "wechat_friend",
          "wechat",
          "wechat_collect",
          "weibo",
          "sns",
          "qzone",
          "snapshot"
        ]
      }
    };
    bridge.callHandler('nativeEvent', send, res => {
      const result = JSON.parse(res);
      if (result.code === 0) {
        const social = result.params.social;
        showCanShare(social);
      }
    })
  };

  useEffect(() => {
    canShare();
  }, []);

  const handleShare = (item) => {
    console.log(userName, 'userName');
    let sendData = {
      event: 'webData',
      params: {
        action: 'essayData',
        data: {
          C_TITLE: (userName || '') + '邀请您参加专享福利活动，新周边&VIP免费送',
          C_TITLE_IMG: 'https://file.wogoo.com/app/logo/logo120.png',
          C_INTRODUCE: "市值风云新用户专享福利活动，100%中奖，天天抽，天天乐",
          C_IMG: "",
          ARTICLE_ID: 'a76767d26311439786c35ea8dc11a253',
          C_CONTENT: '123',
          shareImg: 'https://file.wogoo.com/app/logo/logo120.png',
          share_url: `${process.env.REACT_APP_DEMAND_URL}active_120?userName=${userName || ''}`,
        }
      }
    }
    bridge.callHandler('nativeEvent', sendData, res => {})
    const event = {
      event: 'shareToSocial',
      params: {
        title: (userName || '') + '邀请您参加专享福利活动，新周边&VIP免费送',
        subtitle: '市值风云新用户专享福利活动，100%中奖，天天抽，天天乐',
        image: 'https://file.wogoo.com/app/logo/logo120.png',
        url: `${process.env.REACT_APP_DEMAND_URL}active_120?userName=${userName || ''}`,
        articleID: '',
        social: item,
        isActivtiy: true
      }
    }
    bridge.callHandler('nativeEvent', event, res => {
      const result = JSON.parse(res);
      if (result.code === 0) {}
    });
    onShareClick && onShareClick(item);
    setVisible(false)
    // 安卓会莫民奇妙弹出导航栏
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'nativeControl',
        params: {
          navigation: {
            visibility: false
          },
          container: {},
          bottomToolbar: {
            visibility: false
          }
        }
      },
      () => {}
    );
  }

  return (
    <FloatLayout
      content={
        <Container className="float-table-wrap">
          {social.length === 0 && <div className="share-text">暂无分享渠道</div>}
          <div className="social-wrap">
            {social.map(item => {
              return <div onClick={() => handleShare(item)} className="social-item">
                <img src={socialList[item]} alt='' className="social-img"/>
                <div className="social-item-text">{socialItemName[item]}</div>
              </div>
            })}
          </div>
          <div onClick={() => setVisible(false)} className="cancel-share">取消</div>
        </Container>
      }
      visible={visible}
      onOverlayClick={() => setVisible(false)}
    />
  )
})

export default React.memo(ShareModal);



// WEBPACK FOOTER //
// ./src/views/activity_120/components/share.js